var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({attrs:{"id":_vm.id,"type":_vm.type,"size":_vm.size,"data-clipboard-text":_vm.copyValue}},'el-button',_vm.$attrs,false),_vm.$listeners),[(_vm.$slots.default)?[_vm._t("default")]:[_vm._v(" 复制 ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }